import { Temporal } from "temporal-polyfill";

export { Temporal };

/** Единственная подменяемая точка получения текущего момента в UI. */
export const clock = { now: (): Temporal.Instant => Temporal.Now.instant() };
